import BasicAlert from './basic-alert';

export default BasicAlert;
